export var GameStatus;
(function (GameStatus) {
    GameStatus["NotStarted"] = "NotStarted";
    GameStatus["InProgress"] = "InProgress";
    GameStatus["RaceOff"] = "RaceOff";
    GameStatus["Resulted"] = "Resulted";
})(GameStatus || (GameStatus = {}));
//# sourceMappingURL=GameStatus.js.map